import { eventBus } from '@/libs/event-bus'

class PhotoArchiveInsert {
  constructor(quill, options = {}) {
    this.quill = quill
    this.options = options
    const toolbar = quill.getModule('toolbar')

    if (toolbar) {
      toolbar.addHandler('photo-archive', this.openPicker.bind(this))
    }
  }

  openPicker() {
    const range = this.quill.getSelection(true) || { index: this.quill.getLength(), length: 0 }

    eventBus.$emit('open-photo-archive-picker', {
      quill: this.quill,
      range,
      startId: this.options.startId,
      requireStartPick: this.options.requireStartPick,
      includeStartInShortcode: this.options.includeStartInShortcode,
    })
  }
}

export default PhotoArchiveInsert
